import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { checkUserHasRole } from "../auth/Utils";

export const schoolMeetingUrl =
  "https://calendly.com/ashley-smith-fruitify/30min";

export const canExploreSchoolAccess = (user) =>
  Boolean(
    user?.isLoggedIn &&
      user.info?.activeContext?.hasApprovedSubscription === false &&
      user.info.activeContext.roleAssignment?.role?.code === "teacher" &&
      checkUserHasRole({ user, role: "teacher" }),
  );

export function SchoolAccessContent() {
  return (
    <Stack spacing={2}>
      <Typography>
        Integrate with your school’s MIS through Wonde to sync classes, teachers
        and student data automatically, reducing manual setup and ongoing
        administration.
      </Typography>
      <Typography>
        Explore insights across classes and departments to identify strengths,
        learning gaps and where support is needed.
      </Typography>
      <Typography>
        <strong>
          Our Starter package is also available to schools and remains free.
        </strong>
      </Typography>
      <Typography>
        Book a meeting with us to discuss your school’s needs, see how the
        integration works and explore departmental access and school-wide
        reporting.
      </Typography>
    </Stack>
  );
}

export function SchoolAccessDialog({ onClose }) {
  return (
    <Dialog
      open
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      aria-labelledby="school-access-title"
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
    >
      <DialogTitle id="school-access-title">Explore school access</DialogTitle>
      <DialogContent dividers>
        <SchoolAccessContent />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
        <Button
          component="a"
          href={schoolMeetingUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
        >
          Book a meeting
        </Button>
      </DialogActions>
    </Dialog>
  );
}
